export default {
      id: "icon-pomme-usage",
      viewBox: "0 0 114.4 111",
      url: __webpack_public_path__ + "icons.svg#icon-pomme",
      toString: function () {
        return this.url;
      }
    }